export default __webpack_public_path__ + "static/media/choosing_the_parameters_2.03c6e804.png";